"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _enums = require("../enums");

const {
  AB
} = _enums.experimentTypeEnum;
const {
  RUNNING
} = _enums.experimentStatusEnum;
const {
  PRODUCTION
} = _enums.experimentEnvironmentEnum;

const checkExperimentReset = ({
  experimentTypeId,
  experimentStatusId,
  environmentId
}) => {
  return experimentTypeId !== AB || experimentStatusId !== RUNNING || environmentId !== PRODUCTION;
};

var _default = checkExperimentReset;
exports.default = _default;